import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  trackBrochureRequest, 
  trackFormSubmission, 
  trackUserInteraction,
  trackPageView,
  initializeGA 
} from '../utils/analytics';
import './BrochureGrid.css';

const BrochureGrid = () => {
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [selectedBrochure, setSelectedBrochure] = useState(null);
  const navigate = useNavigate();

  // Initialize GA4 when component mounts
  useEffect(() => {
    initializeGA();
    // Track page view
    trackPageView('Brochures Page', window.location.pathname);
  }, []);

  const brochures = [
    {
      id: '934',
      coverImage: 'https://media.gadventures.com/media-server/cache/b9/db/b9db69b33e6837601cc93b978fb9d834.jpg',
      title: 'Earth 2025 CA',
      description: 'Representing the quintessential G Adventures experience, our Earth brochure features a wide selection of our Classic tours, as well as tours from our Active, Marine, and Wellness Travel Styles too.',
      ebrochureUrl: 'https://gadventures.revolutiontravel.ca/brochures/2025-earth-cad.pdf'
    },
    {
      id: '935',
      coverImage: 'https://media.gadventures.com/media-server/cache/5d/4e/5d4e6824090a2f7729fe6d8b3627890e.jpg',
      title: 'National Geographic Journeys 2025 CA',
      description: 'Discover Journeys, a collection of unique experiences that offer greater hands-on exploration, access to people and projects supported by National Geographic or G Adventures.',
      ebrochureUrl: 'https://gadventures.revolutiontravel.ca/brochures/2025-journeys-cad.pdf'
    },
    {
      id: '936',
      coverImage: 'https://media.gadventures.com/media-server/cache/74/ce/74ceae0d05c41f7ad9c7e5842554b0e7.jpg',
      title: '18-to-Thirtysomethings 2025 CA',
      description: 'Made for young, budget-minded travellers looking to squeeze the most out of the world\'s best destinations, these definitely aren\'t your typical big-bus tours.',
      ebrochureUrl: 'https://gadventures.revolutiontravel.ca/brochures/2025-18-30s-cad.pdf'
    },
    {
      id: '937',
      coverImage: 'https://media.gadventures.com/media-server/cache/6f/41/6f41ce4547c3fd7961db828a43c3c332.jpg',
      title: 'Geluxe 2025 CA',
      description: 'Meet Geluxe, a collection of premium active adventures expertly curated to keep you feeling oh-so comfortable.',
      ebrochureUrl: 'https://gadventures.revolutiontravel.ca/brochures/2025-geluxe-cad.pdf'
    }
  ];

  const handleBrochureRequest = (brochure) => {
    setSelectedBrochure(brochure);
    setShowModal(true);
    // Track brochure interaction
    trackUserInteraction('brochure_click', 'engagement', brochure.title);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedBrochure || !email || !name) {
      return;
    }
    
    try {
      const response = await fetch('https://gadventures.revolutiontravel.ca:5656/api/brochure/request', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          brochureId: selectedBrochure.id,
          brochureTitle: selectedBrochure.title,
          brochureUrl: selectedBrochure.ebrochureUrl
        }),
      });

      const rawResponse = await response.text();
      console.log('Raw API Response:', rawResponse);
      
      let responseData;
      try {
        responseData = JSON.parse(rawResponse);
      } catch (parseError) {
        console.error('Failed to parse response as JSON:', {
          status: response.status,
          statusText: response.statusText,
          rawResponse
        });
        throw new Error(`Server returned invalid JSON response (Status: ${response.status}). Raw response: ${rawResponse.substring(0, 200)}`);
      }

      if (!response.ok) {
        throw new Error(`Failed to send brochure request: ${responseData.error || response.statusText}`);
      }

      // Track successful brochure request
      trackBrochureRequest(selectedBrochure.id, selectedBrochure.title);
      trackFormSubmission('brochure_request', 'lead_form', true);
      
      // Track conversion event
      window.gtag('event', 'conversion', {
        'send_to': 'AW-CONVERSION_ID/CONVERSION_LABEL', // Replace with your actual conversion tracking IDs
        'value': 1.0,
        'currency': 'CAD',
        'transaction_id': selectedBrochure.id
      });

      console.log('Brochure request sent successfully for:', email);

      // Navigate to brochure viewer
      window.location.href = selectedBrochure.ebrochureUrl;

      setEmail('');
      setShowModal(false);
      setSelectedBrochure(null);

    } catch (error) {
      console.error('Failed to submit brochure request:', error);
      // Track failed submission
      trackFormSubmission('brochure_request', 'lead_form', false);
      alert('Sorry, there was an error requesting the brochure. Please try again.');
    }
  };

  return (
    <div className="brochure-content">
      <div>
        <p>
          Overflowing with adventure-y goodness, flip through our brochures and find where in our big, beautiful world you want to explore next.
        </p>
      </div>

      <form method="post" action="">
        <div id="brochures-grid" className="row-fluid">
          {brochures.map((brochure) => (
            <div key={brochure.id} className="brochureContainer">
              <div className="boxgrid slideright" data-ceid="Brochure Cover">
                <img
                  className="cover"
                  src={brochure.coverImage}
                  width="200"
                  height="259"
                  alt={brochure.title}
                  style={{ left: 0 }}
                />
                <h4>{brochure.title}</h4>
                <p>{brochure.description}</p>
              </div>

              <div className="bro-details-btn">Rollover brochure for details</div>

              <div className="brochure-actions">
                <button
                  type="button"
                  className="bro-viewDigital"
                  onClick={() => handleBrochureRequest(brochure)}
                >
                  View the digital edition
                </button>
              </div>
            </div>
          ))}
        </div>
      </form>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              type="button"
              className="modal-close"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
            <h3>View Digital Brochure</h3>
            <p>Enter your email to view "{selectedBrochure?.title}" brochure</p>
            <form onSubmit={handleSubmit} className="email-form">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                required
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
              />
              <button type="submit">View digital brochure</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default BrochureGrid;